<template>
  <div>
    <h1>
      OOFTOP<br />Politique de cookies de la solution de valorisation de biens
      immobiliers<br />Mis à jour le 2/01/2023
    </h1>
    <p>
      OOFTOP souhaite vous informer de manière claire et transparente sur
      l&rsquo;usage des cookies lorsque vous utilisez la solution de
      valorisation de biens immobiliers OOFTOP.
    </p>
    <h2>1. Préambule</h2>
    <p>
      Pour permettre aux utilisateurs de bénéficier des services proposés par la
      solution de valorisation de biens immobiliers OOFTOP (ci-après « Ooftop »)
      tels que sa consultation, l&rsquo;optimisation de son utilisation ou sa
      personnalisation en fonction de l&rsquo;utilisateur, Ooftop utilise des
      cookies. Les données personnelles collectées notamment via les cookies par
      Ooftop sont traitées par IDANS DIGITAL (SAS au capital de 5.000 € - 12,
      rue Saint-Fiacre – 75002 Paris – 843&nbsp;534&nbsp;132 RCS Paris)
    </p>
    <p>
      Vous pouvez à tout moment désactiver les cookies auxquels vous avez
      consenti, et ce gratuitement, à partir des possibilités de désactivation
      qui vous sont offertes et rappelées ci-après.
    </p>
    <h2>2. Définitions</h2>
    <p>
      Les cookies sont des informations relatives à la navigation de votre
      terminal (ordinateur, tablette, smartphone, etc.) sur Ooftop. Ils sont
      utilisés pour envoyer des informations à votre navigateur et permettre à
      ce navigateur de renvoyer des informations à Ooftop (par exemple un
      identifiant de session ou le choix d&rsquo;une langue).
    </p>
    <p>
      Seul l&rsquo;émetteur d&rsquo;un cookie peut lire ou modifier les
      informations qui y sont contenues.
    </p>
    <p>
      Il existe différents types de cookies :<br />
      - des cookies de session qui disparaissent dès que vous quittez Ooftop
      ;<br />
      - des cookies permanents qui demeurent sur votre terminal jusqu&rsquo;à
      expiration de leur durée de vie ou jusqu&rsquo;à ce que vous les
      supprimiez à l&rsquo;aide des fonctionnalités de votre navigateur.<br />
      Vous êtes informés que, lors de vos visites sur Ooftop, des cookies
      peuvent être installés sur votre équipement terminal.
    </p>
    <h2>3. Finalités et type de cookies utilisés</h2>
    <p>
      Le seul cookie utilisé sur Ooftop est nécessaire au fonctionnement
      d&rsquo;Ooftop, sans lesquels l&rsquo;expérience de navigation de
      l&rsquo;utilisateur d&rsquo;Ooftop serait fortement dégradée :
    </p>
    <h3>
      Ce Cookie est nécessaire au bon fonctionnement du Site et à sa navigation.
      Il vous permet d&rsquo;accéder aux principales fonctionnalités du Site.
    </h3>
    <table border="0" cellspacing="3" cellpadding="0">
      <tr>
        <td width="158">
          <p><strong>Catégories de cookies</strong></p>
        </td>
        <td width="274">
          <p><strong>Finalité</strong></p>
        </td>
        <td width="139">
          <p><strong>Durée de conservation</strong></p>
        </td>
      </tr>
      <tr>
        <td width="158"><p>Cookie d&rsquo;identifiants de session</p></td>
        <td width="274">
          <p>
            strictement nécessairement au fonctionnement du Site qui a pour
            finalité de maintenir la session du membre suite à son
            identification
          </p>
        </td>
        <td width="139"><p>30 minutes</p></td>
      </tr>
    </table>

    <h3>&nbsp;</h3>
    <h3>
      Conformément aux recommandations de la CNIL, ce cookie est dispensé du
      recueil préalable de votre consentement. Vous pouvez vous y opposer et le
      supprimer en utilisant les paramètres de votre navigateur, cependant vous
      ne pourrez pas avoir accès à l&rsquo;utilisation d&rsquo;Ooftop.
    </h3>
    <strong><br clear="all" /> </strong>
    <h2>4. Protection des données personnelles</h2>
    <p>
      Dans le cadre de l&rsquo;utilisation des cookies telle que décrite
      ci-dessus, Ooftop sera, en tant que responsable du traitement, susceptible
      de traiter des données à caractère personnel vous concernant.
    </p>
    <p>
      Les données collectées sont indispensables pour atteindre les objectifs
      poursuivis par chaque cookie. Elles sont uniquement destinées aux services
      habilités d&rsquo;Ooftop.
    </p>
    <p>
      En application des dispositions du Règlement général sur la protection des
      données, les personnes disposent d&rsquo;un droit d&rsquo;interrogation,
      d&rsquo;accès, de rectification d&rsquo;effacement, d&rsquo;opposition
      pour motifs légitimes et de portabilité relativement à l&rsquo;ensemble
      des données. Pour de plus amples informations, notamment sur
      l&rsquo;exercice de vos droits, reportez-vous à notre Politique de
      protection des données consultable à l&rsquo;adresse suivante
      <a href="https://www.ooftop.fr/donnees-personnelles-cookies/"
        >https://www.ooftop.fr/donnees-personnelles-cookies/</a
      >
    </p>
  </div>
</template>

<script>
export default {
  name: "COOKIES",
};
</script>
